export default __webpack_public_path__ + "static/media/RoleCandidate.323ef33c.svg";